<div class="flex gap-2 items-center">
	<p [class]="labelClass">Order number</p>
	<div class="flex flex-1 gap-2">
		<app-input
			[ngModel]="referenceNumber"
			(debounce)="setReferenceNumber($event)"
			[testHook]="testHooks.ReferenceNumber"
		></app-input>
		<!-- this div is intentional -->
		<div class="w-5"></div>
	</div>
</div>
